import React from 'react';
import { DriverReviewsSummary, InsightsPeriod } from 'types/PropertyInsights';
import { formatCount, insightsPeriodLabels } from '../helpers';
import StarIcon from 'components/Icons/StarIcon';
import styles from './DriverReviewsWidget.module.css';

type DriverReviewsSummaryProps = {
    summary: DriverReviewsSummary;
};

const ratingLabelsAndField: { label: string; field: keyof DriverReviewsSummary }[] = [
    { label: '5', field: 'five_star_count' },
    { label: '4', field: 'four_star_count' },
    { label: '3', field: 'three_star_count' },
    { label: '2', field: 'two_star_count' },
    { label: '1', field: 'one_star_count' },
];

function Summary({ summary }: DriverReviewsSummaryProps): JSX.Element {
    return (
        <div className={styles.summaryWrapper}>
            <div className={styles.summaryContainer}>
                <div className={styles.summary}>
                    <div className={styles.summaryRating}>
                        <StarIcon /> <h1>{summary.avg_rating}</h1>
                    </div>
                    <p className={styles.summaryTotalReviews}>{formatCount(summary.total_reviews)}</p>
                    <span className={styles.summaryPeriod}>
                        reviews in
                        {summary.period === InsightsPeriod.ALL_TIME
                            ? ' all time'
                            : ` the ${insightsPeriodLabels[summary.period]}`}
                    </span>
                </div>
                <div className={styles.summaryRatings}>
                    {ratingLabelsAndField.map(({ label, field }) => (
                        <div key={label} className={styles.summaryRatingBarRow}>
                            <span>{label}</span>
                            <div className={styles.summaryRatingBar}>
                                <div
                                    className={styles.summaryRatingBarFill}
                                    style={{ width: `${((summary[field] as number) / summary.total_reviews) * 100}%` }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Summary;
